import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import CateringContext from '../../../CateringContext';
import CateringEventContext from '../CateringEventContext';
//import Conversation from './Conversation';
import { TextField, MenuItem, Typography, Grid, Button } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment-timezone';
import { useStyles } from '../../../../home/useStyles';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
import Utils from '../../../../utils/Utils';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import DisplayBasicEventInfo from './DisplayBasicEventInfo';
import AddOrEditBasicEventInfo from './AddOrEditBasicEventInfo';

const BasicEventInfo = (props) => {
    const { updateExistingEvent } = props;
    const classes = useStyles();
    const { restauHook } = useContext(RestauInfoContext);
    const {
        eventType,
        eventStatus,
        formConfig,
        formFields,
        form,
        updateForm,
        loading,
        setLoading,
        configLoading,
        lostReasons,
        rejectReasons,
        newEventPage,
        retrieveEventsByInquiryId,
        setDisplayTitle,
        setLoadingSummaryData,
        processConversationData,
        setConversation,
        setEventOrder,
        renderField,
    } = useContext(CateringContext);
    const { RestauId, CateringInquiryId } = useParams();
    const { requiredFields, errors } = useContext(CateringEventContext);
    const [showInternalNotes, setShowInternalNotes] = React.useState(false);
    const [openEditDialog, setOpenEditDialog] = React.useState(false);

    useEffect(() => {
        //debugger;
        setLoading(true);
        setEventOrder({});
        const updateFormData = async () => {
            //debugger;
            let response = await retrieveEventsByInquiryId(
                RestauId,
                CateringInquiryId
            );
            //if (!response) return;
            let { inquiryData } = response?.data ? response.data : {};
            let eventData = inquiryData?.events && inquiryData?.events[0];
            if (inquiryData?.conversationData) {
                if (inquiryData.conversationData.conversation) {
                    setConversation(inquiryData.conversationData.conversation);
                } else {
                    setConversation(inquiryData.conversationData);
                }

                //if there is no summary data, then this conversation has not ended or failed to end.
                //Try to summarize the conversation with ai now
                if (
                    !inquiryData.conversationData.summary
                    //|| !inquiryData.conversationData.summary.eventDate
                ) {
                    setLoadingSummaryData(true);
                    response = await processConversationData(
                        RestauId,
                        CateringInquiryId
                    );
                    if (response.data) {
                        if (
                            response.data.status &&
                            response.data.status === true
                        ) {
                            //processed and fetched the inquiry data again.
                            console.log(
                                'Summarized Inquiry data: ',
                                response.data.inquiryData
                            );
                            eventData = response.data.inquiryData[0];
                        } else {
                            //failed to summarize the conversation data
                            console.log(
                                'Failed to summarize the conversation data.'
                            );
                        }
                    }
                    setLoadingSummaryData(false);
                }
            } else {
                setConversation(null);
            }

            //debugger;
            // To update later for multiple events under the same inquiryId
            const { orders, ...formData } = eventData || {};
            updateForm(formData);

            // Handle orders data for MenuSelection component
            if (orders) {
                setEventOrder(orders);
            } else {
                // Initialize empty order structure for new events
                const defaultOrder = {
                    items: {},
                    discount: {
                        amount: 0,
                        amount_off: 0,
                        discount_type: 'Dollar',
                    },
                    payment_subtotal_original: 0,
                    payment_subtotal_before_discount: 0,
                    payment_subtotal: 0,
                    payment_salestax: 0,
                    payment_salestax_percent: 0,
                    payment_total: 0,
                    tip: 0,
                    orderInstruction: '',
                    orderInstructionInternal: '',
                    deposit_payment: false,
                    deposit_amount_paid: 0,
                    deposit_amount: 0,
                    deposit_payment_success: false,
                    deposit_payment_method: '',
                    deposit_payment_success_timestamp: '',
                    deposit_payment_collected_by: '',
                    deposit_paid_via_stripe: false,
                    invoice_payment: false,
                    invoice_amount_paid: 0,
                    invoice_payment_success: false,
                    invoice_payment_method: '',
                    invoice_payment_success_timestamp: '',
                    invoice_payment_collected_by: '',
                    invoice_paid_via_stripe: false,
                    orderType: 'catering',
                };
                setEventOrder(defaultOrder);
            }

            // let eventTitle = eventData?.eventName
            //     ? eventData.eventName
            //     : eventData?.customerName
            //     ? eventData.customerName + "'s Event"
            //     : 'Unknown Event';
            let eventTitle = eventData?.eventName
                ? eventData.eventName
                : (eventData?.customerName
                      ? eventData.customerName
                      : 'No Name') + "'s Event";

            setDisplayTitle(eventTitle);

            setLoading(false);
        };
        updateFormData();
    }, [CateringInquiryId]);

    useEffect(() => {
        //debugger;
        if (form && form.internalNotes && form.internalNotes.length > 0) {
            setShowInternalNotes(true);
        } else {
            setShowInternalNotes(false);
        }
    }, [form]);

    return (
        <div>
            {configLoading ||
            loading ||
            !restauHook ||
            !restauHook.restauTimeZone ? (
                <img
                    className={classes.loadingImage}
                    src="/img/spinner.gif"
                    alt="loading"
                />
            ) : (
                formConfig &&
                form && (
                    <Grid container>
                        <AddOrEditBasicEventInfo
                            openEditDialog={openEditDialog}
                            setOpenEditDialog={setOpenEditDialog}
                            formConfig={formConfig}
                            form={form}
                            renderField={(field) => renderField(field, errors)}
                            updateExistingEvent={updateExistingEvent}
                        />

                        <DisplayBasicEventInfo
                            form={form}
                            formConfig={formConfig}
                            renderField={(field) => renderField(field, errors)}
                            setOpenEditDialog={setOpenEditDialog}
                            newEventPage={newEventPage}
                        />

                        <Grid
                            container
                            item
                            spacing={1}
                            sx={{ alignItems: 'flex-start' }}
                        >
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <Typography color="primary" variant="h6">
                                    Internal Details
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} alignItems={'center'}>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <TextField
                                        required
                                        select
                                        id="eventStatus"
                                        label="Event Status"
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        helperText={
                                            !errors.eventStatus
                                                ? null
                                                : errors.eventStatus
                                        }
                                        error={!!errors.eventStatus}
                                        value={form.eventStatus}
                                        sx={{ width: '90%' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(e) =>
                                            updateForm({
                                                eventStatus: e.target.value,
                                            })
                                        }
                                    >
                                        {eventStatus.map((n) => (
                                            <MenuItem
                                                key={n.value}
                                                value={n.value}
                                            >
                                                {n.value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Button
                                        size="small"
                                        disabled={
                                            form.internalNotes &&
                                            form.internalNotes.length > 0
                                        }
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: 1,
                                            mt: 1,
                                            //p: 1,
                                            // pr: 3,
                                        }}
                                        onClick={() => {
                                            setShowInternalNotes(
                                                !showInternalNotes
                                            );
                                        }}
                                    >
                                        <AddCircleSharpIcon
                                            color="primary"
                                            sx={{ fontSize: 26 }}
                                        />
                                        <Typography
                                            sx={{ ml: 0.5 }}
                                            //variant="body1"
                                        >
                                            Add Internal Notes
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>

                            {form.eventStatus === 'FollowUp' && (
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <div>
                                        <DatePicker
                                            size="small"
                                            label="Follow-up Due Date"
                                            variant="outlined"
                                            autoOk
                                            value={
                                                form.followupDueDate
                                                    ? Utils.convertTimestamp(
                                                          form.followupDueDate,
                                                          1,
                                                          true
                                                      )
                                                    : null
                                            }
                                            onChange={(newDate) => {
                                                updateForm({
                                                    followupDueDate: newDate,
                                                });
                                            }}
                                            inputVariant="outlined"
                                            margin="normal"
                                            minDate={moment().add(0, 'days')}
                                            maxDate={moment().add(90, 'days')}
                                            renderInput={(params) => (
                                                <TextField
                                                    size="small"
                                                    margin="normal"
                                                    sx={{
                                                        width: '90%',
                                                    }}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid>
                            )}

                            {form.eventStatus === 'Lost' && (
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <div>
                                        <TextField
                                            required
                                            select
                                            id="eventStatusReason"
                                            label="Reason for Lost Event"
                                            size="small"
                                            variant="outlined"
                                            margin="normal"
                                            value={form.eventStatusReason}
                                            sx={{ width: '90%' }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) =>
                                                updateForm({
                                                    eventStatusReason:
                                                        e.target.value,
                                                })
                                            }
                                        >
                                            {lostReasons.map((n) => (
                                                <MenuItem key={n} value={n}>
                                                    {n}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                </Grid>
                            )}

                            {form.eventStatus === 'Rejected' && (
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <div>
                                        <TextField
                                            required
                                            select
                                            id="eventStatusReason"
                                            label="Reason for Rejected Event"
                                            size="small"
                                            variant="outlined"
                                            margin="normal"
                                            value={form.eventStatusReason}
                                            sx={{ width: '90%' }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) =>
                                                updateForm({
                                                    eventStatusReason:
                                                        e.target.value,
                                                })
                                            }
                                        >
                                            {rejectReasons.map((n) => (
                                                <MenuItem key={n} value={n}>
                                                    {n}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                </Grid>
                            )}

                            {form.eventStatusReason === 'Other' && (
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <div>
                                        <TextField
                                            id="OtherStatusReasons"
                                            label="Reason Description"
                                            size="small"
                                            variant="outlined"
                                            margin="normal"
                                            multiline
                                            minRows={1}
                                            value={form.OtherStatusReasons}
                                            sx={{ width: '90%' }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) =>
                                                updateForm({
                                                    OtherStatusReasons:
                                                        e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </Grid>
                            )}

                            {showInternalNotes && (
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <TextField
                                        id="InternalNotes"
                                        label="Internal Notes"
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        multiline
                                        minRows={3}
                                        value={form.internalNotes}
                                        sx={{ width: '90%' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(e) =>
                                            updateForm({
                                                internalNotes: e.target.value,
                                            })
                                        }
                                    />
                                </Grid>
                            )}
                        </Grid>

                        {/* {newEventPage ? null : (
                            <div>
                                <Typography>
                                    Submitted on:{' '}
                                    {Utils.convertTimestamp(
                                        form.submissionTimestamp,
                                        3,
                                        false,
                                        restauHook.restauTimeZone
                                    )}
                                </Typography>
                                <Typography>Source : {form.source}</Typography>
                                <Conversation />
                            </div>
                        )} */}
                    </Grid>
                )
            )}
        </div>
    );
};

export default BasicEventInfo;
